<template>
  <div>
    <div class="text-[14px] text-white my-2" v-if="showLabel">{{ label }}</div>
    <div class="flex items-center rounded-lg relative">
      <Image :src="icon" class="w-6 h-6 mx-2 !absolute left-2" />
      <van-field :placeholder="placeholder" v-model="inputValue"
        class="text-white flex-1 !text-[15px] h-[44px] bg-[var(--inner-table-bg-color40)] border-none outline-none pl-14 rounded-[8px]"
        @input="handleInput" @focus="handleFocus" :inputmode="
          props.label.indexOf('CPF') > -1 || props.label.indexOf('Telefone') > -1
            ? 'numeric'
            : 'text'
  " :maxlength="props.label.indexOf('CPF') > -1 ? 11 : undefined" :type="inputType" />
    </div>
    <div v-if="errorMessage"
      class="bg-[var(--inner-table-bg-color40)] text-white rounded flex items-start justify-center text-[12px] py-2 text-center errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { isInPWA, isIOS } from '@/env';
const props: any = defineProps({
  label: String,
  showLabel: {
    type: Boolean,
    default: true,
  },
  placeholder: String,
  modelValue: String,
  icon: String,
  errorMessage: {
    type: String,
    default: "",
  },
  inputType: {
    type: String as any,
    default: "text",
  },
});

const emit = defineEmits(["update:modelValue", "input", "focus"]);

const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    // 如果输入的是CPF，则只允许输入数字
    let value = props.label.indexOf("Nome") > -1 ? newValue : newValue.trim();
    if (props.label && (props.label.indexOf("CPF") > -1 || props.label.indexOf("Telefone") > -1)) {
      value = value.replace(/[^0-9]/g, "");
    }
    inputValue.value = value;
  }
);

const handleInput = (e) => {
  let value = props.label.indexOf("Nome") > -1 ? e.target.value : e.target.value.trim();
  // 如果输入的是CPF，则只允许输入数字
  if (props.label && (props.label.indexOf("CPF") > -1 || props.label.indexOf("Telefone") > -1)) {
    value = value.replace(/[^0-9]/g, "");
  }
  inputValue.value = value;
  emit("update:modelValue", value);
  emit("input", e);
};

const handleFocus = (e: FocusEvent) => {
  if (isIOS && isInPWA) {
    const ori_v = inputValue.value;
    setTimeout(async () => { 
      inputValue.value = '.'
      await nextTick();
      inputValue.value = ori_v
    }, 200);
  }
};
</script>
